import React, { useEffect, useState } from 'react';
import "../time.css";

const Time = () => {
  const [selectedtimezone,setselectedtimezone] = useState("EST")
  const [selectedurl1,setselectedurl1] = useState("")
  const [selectedurl2,setselectedurl2] = useState("")
  const [selectedurl3,setselectedurl3] = useState("")
  const [selectedurl4,setselectedurl4] = useState("")
  const [selectedurl5,setselectedurl5] = useState("")
  // const [selectedurl11, setselectedurl11] = React.useState('');

 

  const handlePasteButtonClick1 = () => {
      navigator.clipboard.readText().then(
          clipText => setselectedurl1(clipText)
      ).catch(error => {
          console.error('Failed to read clipboard contents: ', error);
      });
  };
  const handlePasteButtonClick2 = () => {
    navigator.clipboard.readText().then(
        clipText => setselectedurl2(clipText)
    ).catch(error => {
        console.error('Failed to read clipboard contents: ', error);
    });
};
const handlePasteButtonClick3 = () => {
  navigator.clipboard.readText().then(
      clipText => setselectedurl3(clipText)
  ).catch(error => {
      console.error('Failed to read clipboard contents: ', error);
  });
};
const handlePasteButtonClick4 = () => {
  navigator.clipboard.readText().then(
      clipText => setselectedurl4(clipText)
  ).catch(error => {
      console.error('Failed to read clipboard contents: ', error);
  });
};
const handlePasteButtonClick5 = () => {
  navigator.clipboard.readText().then(
      clipText => setselectedurl5(clipText)
  ).catch(error => {
      console.error('Failed to read clipboard contents: ', error);
  });
};

// const button = document.querySelector('.posting_time')
// const buttonText = button.querySelector('span')

// button.addEventListener('click', () => {
//   button.classList.add('animation');
//   button.disabled = true;
//   buttonText.style.top = '-' + buttonText.offsetHeight + 'px'
//   setTimeout(() => {
//     button.classList.add('active')
//   }, 600)
  
//   setTimeout(() => {
//     button.classList.remove('animation')
//     button.disabled = false;
//     button.querySelector('span').style.top = '0';
//   }, 3000)
// })

  // For example, let's log something when the component mounts
  // Mapping between commonly used timezone identifiers and their IANA equivalents
  const timezoneMapping = {
    "Asia/Calcutta": "Asia/Kolkata"
  };
  
  // Function to populate the dropdown list with all timezones
  
  function getPostId1() {
    const linkedinURL= selectedurl1;
    const regex = /([0-9]{19})/;
    let postId;
    if(linkedinURL !== ""){
      postId = regex.exec(linkedinURL).pop();
    }else{
      postId = "";
    }
    return postId;
  }
  function getPostId2() {
    const linkedinURL= selectedurl2;
    const regex = /([0-9]{19})/;
    let postId;
    if(linkedinURL !== ""){
      postId = regex.exec(linkedinURL).pop();
    }else{
      postId = "";
    }
    return postId;
  }
  function getPostId3() {
    const linkedinURL= selectedurl3;
    const regex = /([0-9]{19})/;
    let postId;
    if(linkedinURL !== ""){
      postId = regex.exec(linkedinURL).pop();
    }else{
      postId = "";
    }
    return postId;
  }
  function getPostId4() {
    const linkedinURL= selectedurl4;
    const regex = /([0-9]{19})/;
    let postId;
    if(linkedinURL !== ""){
      postId = regex.exec(linkedinURL).pop();
    }else{
      postId = "";
    }
    return postId;
  }
  function getPostId5() {
    const linkedinURL= selectedurl5;
    const regex = /([0-9]{19})/;
    let postId;
    if(linkedinURL !== ""){
      postId = regex.exec(linkedinURL).pop();
    }else{
      postId = "";
    }
    return postId;
  }
  
  function extractUnixTimestamp(postId) {
    // Splitting the 64-bit decimal into two 32-bit integers
    const upper = Math.floor(postId / 2**32);
    const lower = postId % 2**32;
    
    // Convert the upper and lower parts to binary strings
    const upperBinary = upper.toString(2);
    const lowerBinary = lower.toString(2).padStart(32, '0');
    
    // Combine the upper and lower parts and extract the first 41 characters
    const asBinary = upperBinary + lowerBinary;
    const first41Chars = asBinary.slice(0, 41);
    
    // Convert the binary string to a decimal timestamp
    const timestamp = parseInt(first41Chars, 2);
    
    return timestamp;
  }
  

  
  function unixTimestampToHumanDate(timestamp, timezone) {
    const dateObject = new Date(timestamp); // Multiply by 1000 to convert seconds to milliseconds
    const options = {
      timeZone: timezone,
      timeZoneName: 'short',
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    };
    const humanDateFormat = dateObject.toLocaleString('en-US', options);
    return humanDateFormat;
  }
  
  // function unixTimestampToHumanDate(timestamp) {
  //   const dateObject = new Date(timestamp);
  //   const humanDateFormat = dateObject.toUTCString()+" (UTC)";
  //   return humanDateFormat;
  // }
  
  function getDate() {

    const button = document.querySelector('#getPostingTime');
    const buttonText = button.querySelector('span')
    if (button) {
      button.classList.add('animation');
      button.disabled = true;
      buttonText.style.top = '-' + buttonText.offsetHeight + 'px'
    }
    
    var timezone = document.getElementById("timezone").value;
    console.log("Selected timezone:", timezone);
    const postIdList = [getPostId1(), getPostId2(), getPostId3(), getPostId4(), getPostId5()];
    postIdList.forEach((postId, index) => {
      if (postId !== "") {
        const unixTimestamp = extractUnixTimestamp(postId);
        const humanDateFormat = unixTimestampToHumanDate(unixTimestamp, timezone);
        document.querySelector(`#date${index + 1}`).textContent = humanDateFormat;
      }
    });

    setTimeout(() => {
      button.classList.remove('animation');
      button.disabled = false;
      buttonText.style.top = '0';
    }, 1000);

    // const postId1 = getPostId1();
    // if(postId1 !== ""){
    //   const unixTimestamp1 = extractUnixTimestamp(postId1);
    //   const humanDateFormat1 = unixTimestampToHumanDate(unixTimestamp1, timezone);
    //   document.querySelector("#date1").textContent = humanDateFormat1;
    // }
    
    // const postId2 = getPostId2();
    // if(postId2 !== ""){
    //   const unixTimestamp2 = extractUnixTimestamp(postId2);
    //   const humanDateFormat2 = unixTimestampToHumanDate(unixTimestamp2, timezone);
    //   document.querySelector("#date2").textContent = humanDateFormat2;
    // }
    
    // const postId3 = getPostId3();
    // if(postId3 !== ""){
    //   const unixTimestamp3 = extractUnixTimestamp(postId3);
    //   const humanDateFormat3 = unixTimestampToHumanDate(unixTimestamp3, timezone);
    //   document.querySelector("#date3").textContent = humanDateFormat3;
    // }
    
    // const postId4 = getPostId4();
    // if(postId4 !== ""){
    //   const unixTimestamp4 = extractUnixTimestamp(postId4);
    //   const humanDateFormat4 = unixTimestampToHumanDate(unixTimestamp4, timezone);
    //   document.querySelector("#date4").textContent = humanDateFormat4;
    // }
    
    // const postId5 = getPostId5();
    // if(postId5 !== ""){
    //   const unixTimestamp5 = extractUnixTimestamp(postId5);
    //   const humanDateFormat5 = unixTimestampToHumanDate(unixTimestamp5, timezone);
    //   document.querySelector("#date5").textContent = humanDateFormat5;
    // }
  }
  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: '\n    body {\n    margin: 1em;\n    font-family: "Helvetica", Arial, sans-serif;\n    font-size: 18px;\n    }\n    button, input {\n    font-size: 16px;\n    }\n    .form {\n    margin-bottom: 1em;\n    width: 870px;\n    margin: 0 auto;\n    text-align: center;\n    }\n    .main{\n    display:flex;\n    }\n    .header {\n    width: 100%;\n    margin: 0 auto;\n    text-align: center;\n    }\n    .header img{\n    width: 200px;\n    }\n    '}}
      />
      <div className="header">
        <a href="https://commenter.ai">
          <img 
            src={"data:image/png;base64,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"
            }
            className="main-logo"
            alt="Main Logo"
          />
        </a>
      </div>
      <br />
      <br />
      <div className="form">
        <label htmlFor="timezone">Select your time zone:</label>
        <select id="timezone" onChange={(e) => { setselectedtimezone(e.target.value) }} value={selectedtimezone}>
        <option value="Africa/Abidjan">Africa/Abidjan</option>
<option value="Africa/Algiers">Africa/Algiers</option>
<option value="Africa/Bissau">Africa/Bissau</option>
<option value="Africa/Cairo">Africa/Cairo</option>
<option value="Africa/Casablanca">Africa/Casablanca</option>
<option value="Africa/Ceuta">Africa/Ceuta</option>
<option value="Africa/El_Aaiun">Africa/El_Aaiun</option>
<option value="Africa/Johannesburg">Africa/Johannesburg</option>
<option value="Africa/Juba">Africa/Juba</option>
<option value="Africa/Khartoum">Africa/Khartoum</option>
<option value="Africa/Lagos">Africa/Lagos</option>
<option value="Africa/Maputo">Africa/Maputo</option>
<option value="Africa/Monrovia">Africa/Monrovia</option>
<option value="Africa/Nairobi">Africa/Nairobi</option>
<option value="Africa/Ndjamena">Africa/Ndjamena</option>
<option value="Africa/Sao_Tome">Africa/Sao_Tome</option>
<option value="Africa/Tripoli">Africa/Tripoli</option>
<option value="Africa/Tunis">Africa/Tunis</option>
<option value="Africa/Windhoek">Africa/Windhoek</option>
<option value="America/Adak">America/Adak</option>
<option value="America/Anchorage">America/Anchorage</option>
<option value="America/Araguaina">America/Araguaina</option>
<option value="America/Argentina/Buenos_Aires">America/Argentina/Buenos_Aires</option>
<option value="America/Argentina/Catamarca">America/Argentina/Catamarca</option>
<option value="America/Argentina/Cordoba">America/Argentina/Cordoba</option>
<option value="America/Argentina/Jujuy">America/Argentina/Jujuy</option>
<option value="America/Argentina/La_Rioja">America/Argentina/La_Rioja</option>
<option value="America/Argentina/Mendoza">America/Argentina/Mendoza</option>
<option value="America/Argentina/Rio_Gallegos">America/Argentina/Rio_Gallegos</option>
<option value="America/Argentina/Salta">America/Argentina/Salta</option>
<option value="America/Argentina/San_Juan">America/Argentina/San_Juan</option>
<option value="America/Argentina/San_Luis">America/Argentina/San_Luis</option>
<option value="America/Argentina/Tucuman">America/Argentina/Tucuman</option>
<option value="America/Argentina/Ushuaia">America/Argentina/Ushuaia</option>
<option value="America/Asuncion">America/Asuncion</option>
<option value="America/Bahia">America/Bahia</option>
<option value="America/Bahia_Banderas">America/Bahia_Banderas</option>
<option value="America/Barbados">America/Barbados</option>
<option value="America/Belem">America/Belem</option>
<option value="America/Belize">America/Belize</option>
<option value="America/Boa_Vista">America/Boa_Vista</option>
<option value="America/Bogota">America/Bogota</option>
<option value="America/Boise">America/Boise</option>
<option value="America/Cambridge_Bay">America/Cambridge_Bay</option>
<option value="America/Campo_Grande">America/Campo_Grande</option>
<option value="America/Cancun">America/Cancun</option>
<option value="America/Caracas">America/Caracas</option>
<option value="America/Cayenne">America/Cayenne</option>
<option value="America/Chicago">America/Chicago</option>
<option value="America/Chihuahua">America/Chihuahua</option>
<option value="America/Ciudad_Juarez">America/Ciudad_Juarez</option>
<option value="America/Costa_Rica">America/Costa_Rica</option>
<option value="America/Cuiaba">America/Cuiaba</option>
<option value="America/Danmarkshavn">America/Danmarkshavn</option>
<option value="America/Dawson">America/Dawson</option>
<option value="America/Dawson_Creek">America/Dawson_Creek</option>
<option value="America/Denver">America/Denver</option>
<option value="America/Detroit">America/Detroit</option>
<option value="America/Edmonton">America/Edmonton</option>
<option value="America/Eirunepe">America/Eirunepe</option>
<option value="America/El_Salvador">America/El_Salvador</option>
<option value="America/Fort_Nelson">America/Fort_Nelson</option>
<option value="America/Fortaleza">America/Fortaleza</option>
<option value="America/Glace_Bay">America/Glace_Bay</option>
<option value="America/Goose_Bay">America/Goose_Bay</option>
<option value="America/Grand_Turk">America/Grand_Turk</option>
<option value="America/Guatemala">America/Guatemala</option>
<option value="America/Guayaquil">America/Guayaquil</option>
<option value="America/Guyana">America/Guyana</option>
<option value="America/Halifax">America/Halifax</option>
<option value="America/Havana">America/Havana</option>
<option value="America/Hermosillo">America/Hermosillo</option>
<option value="America/Indiana/Indianapolis">America/Indiana/Indianapolis</option>
<option value="America/Indiana/Knox">America/Indiana/Knox</option>
<option value="America/Indiana/Marengo">America/Indiana/Marengo</option>
<option value="America/Indiana/Petersburg">America/Indiana/Petersburg</option>
<option value="America/Indiana/Tell_City">America/Indiana/Tell_City</option>
<option value="America/Indiana/Vevay">America/Indiana/Vevay</option>
<option value="America/Indiana/Vincennes">America/Indiana/Vincennes</option>
<option value="America/Indiana/Winamac">America/Indiana/Winamac</option>
<option value="America/Inuvik">America/Inuvik</option>
<option value="America/Iqaluit">America/Iqaluit</option>
<option value="America/Jamaica">America/Jamaica</option>
<option value="America/Juneau">America/Juneau</option>
<option value="America/Kentucky/Louisville">America/Kentucky/Louisville</option>
<option value="America/Kentucky/Monticello">America/Kentucky/Monticello</option>
<option value="America/La_Paz">America/La_Paz</option>
<option value="America/Lima">America/Lima</option>
<option value="America/Los_Angeles">America/Los_Angeles</option>
<option value="America/Maceio">America/Maceio</option>
<option value="America/Managua">America/Managua</option>
<option value="America/Manaus">America/Manaus</option>
<option value="America/Martinique">America/Martinique</option>
<option value="America/Matamoros">America/Matamoros</option>
<option value="America/Mazatlan">America/Mazatlan</option>
<option value="America/Menominee">America/Menominee</option>
<option value="America/Merida">America/Merida</option>
<option value="America/Metlakatla">America/Metlakatla</option>
<option value="America/Mexico_City">America/Mexico_City</option>
<option value="America/Miquelon">America/Miquelon</option>
<option value="America/Moncton">America/Moncton</option>
<option value="America/Monterrey">America/Monterrey</option>
<option value="America/Montevideo">America/Montevideo</option>
<option value="America/New_York">America/New_York</option>
<option value="America/Nome">America/Nome</option>
<option value="America/Noronha">America/Noronha</option>
<option value="America/North_Dakota/Beulah">America/North_Dakota/Beulah</option>
<option value="America/North_Dakota/Center">America/North_Dakota/Center</option>
<option value="America/North_Dakota/New_Salem">America/North_Dakota/New_Salem</option>
<option value="America/Nuuk">America/Nuuk</option>
<option value="America/Ojinaga">America/Ojinaga</option>
<option value="America/Panama">America/Panama</option>
<option value="America/Paramaribo">America/Paramaribo</option>
<option value="America/Phoenix">America/Phoenix</option>
<option value="America/Port-au-Prince">America/Port-au-Prince</option>
<option value="America/Porto_Velho">America/Porto_Velho</option>
<option value="America/Puerto_Rico">America/Puerto_Rico</option>
<option value="America/Punta_Arenas">America/Punta_Arenas</option>
<option value="America/Rankin_Inlet">America/Rankin_Inlet</option>
<option value="America/Recife">America/Recife</option>
<option value="America/Regina">America/Regina</option>
<option value="America/Resolute">America/Resolute</option>
<option value="America/Rio_Branco">America/Rio_Branco</option>
<option value="America/Santarem">America/Santarem</option>
<option value="America/Santiago">America/Santiago</option>
<option value="America/Santo_Domingo">America/Santo_Domingo</option>
<option value="America/Sao_Paulo">America/Sao_Paulo</option>
<option value="America/Scoresbysund">America/Scoresbysund</option>
<option value="America/Sitka">America/Sitka</option>
<option value="America/St_Johns">America/St_Johns</option>
<option value="America/Swift_Current">America/Swift_Current</option>
<option value="America/Tegucigalpa">America/Tegucigalpa</option>
<option value="America/Thule">America/Thule</option>
<option value="America/Tijuana">America/Tijuana</option>
<option value="America/Toronto">America/Toronto</option>
<option value="America/Vancouver">America/Vancouver</option>
<option value="America/Whitehorse">America/Whitehorse</option>
<option value="America/Winnipeg">America/Winnipeg</option>
<option value="America/Yakutat">America/Yakutat</option>
<option value="Antarctica/Casey">Antarctica/Casey</option>
<option value="Antarctica/Davis">Antarctica/Davis</option>
<option value="Antarctica/Macquarie">Antarctica/Macquarie</option>
<option value="Antarctica/Mawson">Antarctica/Mawson</option>
<option value="Antarctica/Palmer">Antarctica/Palmer</option>
<option value="Antarctica/Rothera">Antarctica/Rothera</option>
<option value="Antarctica/Troll">Antarctica/Troll</option>
<option value="Asia/Almaty">Asia/Almaty</option>
<option value="Asia/Amman">Asia/Amman</option>
<option value="Asia/Anadyr">Asia/Anadyr</option>
<option value="Asia/Aqtau">Asia/Aqtau</option>
<option value="Asia/Aqtobe">Asia/Aqtobe</option>
<option value="Asia/Ashgabat">Asia/Ashgabat</option>
<option value="Asia/Atyrau">Asia/Atyrau</option>
<option value="Asia/Baghdad">Asia/Baghdad</option>
<option value="Asia/Baku">Asia/Baku</option>
<option value="Asia/Bangkok">Asia/Bangkok</option>
<option value="Asia/Barnaul">Asia/Barnaul</option>
<option value="Asia/Beirut">Asia/Beirut</option>
<option value="Asia/Bishkek">Asia/Bishkek</option>
<option value="Asia/Chita">Asia/Chita</option>
<option value="Asia/Choibalsan">Asia/Choibalsan</option>
<option value="Asia/Colombo">Asia/Colombo</option>
<option value="Asia/Damascus">Asia/Damascus</option>
<option value="Asia/Dhaka">Asia/Dhaka</option>
<option value="Asia/Dili">Asia/Dili</option>
<option value="Asia/Dubai">Asia/Dubai</option>
<option value="Asia/Dushanbe">Asia/Dushanbe</option>
<option value="Asia/Famagusta">Asia/Famagusta</option>
<option value="Asia/Gaza">Asia/Gaza</option>
<option value="Asia/Hebron">Asia/Hebron</option>
<option value="Asia/Ho_Chi_Minh">Asia/Ho_Chi_Minh</option>
<option value="Asia/Hong_Kong">Asia/Hong_Kong</option>
<option value="Asia/Hovd">Asia/Hovd</option>
<option value="Asia/Irkutsk">Asia/Irkutsk</option>
<option value="Asia/Jakarta">Asia/Jakarta</option>
<option value="Asia/Jayapura">Asia/Jayapura</option>
<option value="Asia/Jerusalem">Asia/Jerusalem</option>
<option value="Asia/Kabul">Asia/Kabul</option>
<option value="Asia/Kamchatka">Asia/Kamchatka</option>
<option value="Asia/Karachi">Asia/Karachi</option>
<option value="Asia/Kathmandu">Asia/Kathmandu</option>
<option value="Asia/Khandyga">Asia/Khandyga</option>
<option value="Asia/Kolkata">Asia/Kolkata</option>
<option value="Asia/Krasnoyarsk">Asia/Krasnoyarsk</option>
<option value="Asia/Kuching">Asia/Kuching</option>
<option value="Asia/Macau">Asia/Macau</option>
<option value="Asia/Magadan">Asia/Magadan</option>
<option value="Asia/Makassar">Asia/Makassar</option>
<option value="Asia/Manila">Asia/Manila</option>
<option value="Asia/Nicosia">Asia/Nicosia</option>
<option value="Asia/Novokuznetsk">Asia/Novokuznetsk</option>
<option value="Asia/Novosibirsk">Asia/Novosibirsk</option>
<option value="Asia/Omsk">Asia/Omsk</option>
<option value="Asia/Oral">Asia/Oral</option>
<option value="Asia/Pontianak">Asia/Pontianak</option>
<option value="Asia/Pyongyang">Asia/Pyongyang</option>
<option value="Asia/Qatar">Asia/Qatar</option>
<option value="Asia/Qostanay">Asia/Qostanay</option>
<option value="Asia/Qyzylorda">Asia/Qyzylorda</option>
<option value="Asia/Riyadh">Asia/Riyadh</option>
<option value="Asia/Sakhalin">Asia/Sakhalin</option>
<option value="Asia/Samarkand">Asia/Samarkand</option>
<option value="Asia/Seoul">Asia/Seoul</option>
<option value="Asia/Shanghai">Asia/Shanghai</option>
<option value="Asia/Singapore">Asia/Singapore</option>
<option value="Asia/Srednekolymsk">Asia/Srednekolymsk</option>
<option value="Asia/Taipei">Asia/Taipei</option>
<option value="Asia/Tashkent">Asia/Tashkent</option>
<option value="Asia/Tbilisi">Asia/Tbilisi</option>
<option value="Asia/Tehran">Asia/Tehran</option>
<option value="Asia/Thimphu">Asia/Thimphu</option>
<option value="Asia/Tokyo">Asia/Tokyo</option>
<option value="Asia/Tomsk">Asia/Tomsk</option>
<option value="Asia/Ulaanbaatar">Asia/Ulaanbaatar</option>
<option value="Asia/Urumqi">Asia/Urumqi</option>
<option value="Asia/Ust-Nera">Asia/Ust-Nera</option>
<option value="Asia/Vladivostok">Asia/Vladivostok</option>
<option value="Asia/Yakutsk">Asia/Yakutsk</option>
<option value="Asia/Yangon">Asia/Yangon</option>
<option value="Asia/Yekaterinburg">Asia/Yekaterinburg</option>
<option value="Asia/Yerevan">Asia/Yerevan</option>
<option value="Atlantic/Azores">Atlantic/Azores</option>
<option value="Atlantic/Bermuda">Atlantic/Bermuda</option>
<option value="Atlantic/Canary">Atlantic/Canary</option>
<option value="Atlantic/Cape_Verde">Atlantic/Cape_Verde</option>
<option value="Atlantic/Faroe">Atlantic/Faroe</option>
<option value="Atlantic/Madeira">Atlantic/Madeira</option>
<option value="Atlantic/South_Georgia">Atlantic/South_Georgia</option>
<option value="Atlantic/Stanley">Atlantic/Stanley</option>
<option value="Australia/Adelaide">Australia/Adelaide</option>
<option value="Australia/Brisbane">Australia/Brisbane</option>
<option value="Australia/Broken_Hill">Australia/Broken_Hill</option>
<option value="Australia/Darwin">Australia/Darwin</option>
<option value="Australia/Eucla">Australia/Eucla</option>
<option value="Australia/Hobart">Australia/Hobart</option>
<option value="Australia/Lindeman">Australia/Lindeman</option>
<option value="Australia/Lord_Howe">Australia/Lord_Howe</option>
<option value="Australia/Melbourne">Australia/Melbourne</option>
<option value="Australia/Perth">Australia/Perth</option>
<option value="Australia/Sydney">Australia/Sydney</option>
<option value="CET">CET</option>
<option value="CST6CDT">CST6CDT</option>
<option value="EET">EET</option>
<option value="EST">EST</option>
<option value="EST5EDT">EST5EDT</option>
<option value="Etc/GMT">Etc/GMT</option>
<option value="Etc/GMT+1">Etc/GMT+1</option>
<option value="Etc/GMT+10">Etc/GMT+10</option>
<option value="Etc/GMT+11">Etc/GMT+11</option>
<option value="Etc/GMT+12">Etc/GMT+12</option>
<option value="Etc/GMT+2">Etc/GMT+2</option>
<option value="Etc/GMT+3">Etc/GMT+3</option>
<option value="Etc/GMT+4">Etc/GMT+4</option>
<option value="Etc/GMT+5">Etc/GMT+5</option>
<option value="Etc/GMT+6">Etc/GMT+6</option>
<option value="Etc/GMT+7">Etc/GMT+7</option>
<option value="Etc/GMT+8">Etc/GMT+8</option>
<option value="Etc/GMT+9">Etc/GMT+9</option>
<option value="Etc/GMT-1">Etc/GMT-1</option>
<option value="Etc/GMT-10">Etc/GMT-10</option>
<option value="Etc/GMT-11">Etc/GMT-11</option>
<option value="Etc/GMT-12">Etc/GMT-12</option>
<option value="Etc/GMT-13">Etc/GMT-13</option>
<option value="Etc/GMT-14">Etc/GMT-14</option>
<option value="Etc/GMT-2">Etc/GMT-2</option>
<option value="Etc/GMT-3">Etc/GMT-3</option>
<option value="Etc/GMT-4">Etc/GMT-4</option>
<option value="Etc/GMT-5">Etc/GMT-5</option>
<option value="Etc/GMT-6">Etc/GMT-6</option>
<option value="Etc/GMT-7">Etc/GMT-7</option>
<option value="Etc/GMT-8">Etc/GMT-8</option>
<option value="Etc/GMT-9">Etc/GMT-9</option>
<option value="Etc/UTC">Etc/UTC</option>
<option value="Europe/Andorra">Europe/Andorra</option>
<option value="Europe/Astrakhan">Europe/Astrakhan</option>
<option value="Europe/Athens">Europe/Athens</option>
<option value="Europe/Belgrade">Europe/Belgrade</option>
<option value="Europe/Berlin">Europe/Berlin</option>
<option value="Europe/Brussels">Europe/Brussels</option>
<option value="Europe/Bucharest">Europe/Bucharest</option>
<option value="Europe/Budapest">Europe/Budapest</option>
<option value="Europe/Chisinau">Europe/Chisinau</option>
<option value="Europe/Dublin">Europe/Dublin</option>
<option value="Europe/Gibraltar">Europe/Gibraltar</option>
<option value="Europe/Helsinki">Europe/Helsinki</option>
<option value="Europe/Istanbul">Europe/Istanbul</option>
<option value="Europe/Kaliningrad">Europe/Kaliningrad</option>
<option value="Europe/Kirov">Europe/Kirov</option>
<option value="Europe/Kyiv">Europe/Kyiv</option>
<option value="Europe/Lisbon">Europe/Lisbon</option>
<option value="Europe/London">Europe/London</option>
<option value="Europe/Madrid">Europe/Madrid</option>
<option value="Europe/Malta">Europe/Malta</option>
<option value="Europe/Minsk">Europe/Minsk</option>
<option value="Europe/Moscow">Europe/Moscow</option>
<option value="Europe/Paris">Europe/Paris</option>
<option value="Europe/Prague">Europe/Prague</option>
<option value="Europe/Riga">Europe/Riga</option>
<option value="Europe/Rome">Europe/Rome</option>
<option value="Europe/Samara">Europe/Samara</option>
<option value="Europe/Saratov">Europe/Saratov</option>
<option value="Europe/Simferopol">Europe/Simferopol</option>
<option value="Europe/Sofia">Europe/Sofia</option>
<option value="Europe/Tallinn">Europe/Tallinn</option>
<option value="Europe/Tirane">Europe/Tirane</option>
<option value="Europe/Ulyanovsk">Europe/Ulyanovsk</option>
<option value="Europe/Vienna">Europe/Vienna</option>
<option value="Europe/Vilnius">Europe/Vilnius</option>
<option value="Europe/Volgograd">Europe/Volgograd</option>
<option value="Europe/Warsaw">Europe/Warsaw</option>
<option value="Europe/Zurich">Europe/Zurich</option>
<option value="HST">HST</option>
<option value="Indian/Chagos">Indian/Chagos</option>
<option value="Indian/Maldives">Indian/Maldives</option>
<option value="Indian/Mauritius">Indian/Mauritius</option>
<option value="MET">MET</option>
<option value="MST">MST</option>
<option value="MST7MDT">MST7MDT</option>
<option value="PST8PDT">PST8PDT</option>
<option value="Pacific/Apia">Pacific/Apia</option>
<option value="Pacific/Auckland">Pacific/Auckland</option>
<option value="Pacific/Bougainville">Pacific/Bougainville</option>
<option value="Pacific/Chatham">Pacific/Chatham</option>
<option value="Pacific/Easter">Pacific/Easter</option>
<option value="Pacific/Efate">Pacific/Efate</option>
<option value="Pacific/Fakaofo">Pacific/Fakaofo</option>
<option value="Pacific/Fiji">Pacific/Fiji</option>
<option value="Pacific/Galapagos">Pacific/Galapagos</option>
<option value="Pacific/Gambier">Pacific/Gambier</option>
<option value="Pacific/Guadalcanal">Pacific/Guadalcanal</option>
<option value="Pacific/Guam">Pacific/Guam</option>
<option value="Pacific/Honolulu">Pacific/Honolulu</option>
<option value="Pacific/Kanton">Pacific/Kanton</option>
<option value="Pacific/Kiritimati">Pacific/Kiritimati</option>
<option value="Pacific/Kosrae">Pacific/Kosrae</option>
<option value="Pacific/Kwajalein">Pacific/Kwajalein</option>
<option value="Pacific/Marquesas">Pacific/Marquesas</option>
<option value="Pacific/Nauru">Pacific/Nauru</option>
<option value="Pacific/Niue">Pacific/Niue</option>
<option value="Pacific/Norfolk">Pacific/Norfolk</option>
<option value="Pacific/Noumea">Pacific/Noumea</option>
<option value="Pacific/Pago_Pago">Pacific/Pago_Pago</option>
<option value="Pacific/Palau">Pacific/Palau</option>
<option value="Pacific/Pitcairn">Pacific/Pitcairn</option>
<option value="Pacific/Port_Moresby">Pacific/Port_Moresby</option>
<option value="Pacific/Rarotonga">Pacific/Rarotonga</option>
<option value="Pacific/Tahiti">Pacific/Tahiti</option>
<option value="Pacific/Tarawa">Pacific/Tarawa</option>
<option value="Pacific/Tongatapu">Pacific/Tongatapu</option>
<option value="WET">WET</option>
</select>
        <br />
        <br />
        <div className="main">
          <span>LinkedIn post URL 1&nbsp;&nbsp;</span>
          {/* <input type="text" id="url1" name="url1" onChange={(e) => { setselectedurl1(e.target.value) }} value={selectedurl1} />
          &nbsp;&nbsp; */}
          {/* <button id="pasteButton" class="posting_time" style={{backgroundColor:'#0050b2', color:'#fff', border: '0px', borderRadius:'5px', padding:'5px', cursor:'pointer', marginBottom:'5px' }}>Paste</button> */}
          <input type="text" id="url1" name="url1" onChange={(e) => { setselectedurl1(e.target.value) }} value={selectedurl1} />
          &nbsp;&nbsp;
          <button id="pasteButton" className="posting_time" style={{backgroundColor:'#0050b2', color:'#fff', border: '0px', borderRadius:'5px', padding:'5px', cursor:'pointer', marginBottom:'5px' }} onClick={handlePasteButtonClick1}>Paste</button>

          &nbsp;&nbsp;
          <div className="output">
            <span id="label">Posted on: </span>
            <span id="date1" />
          </div>
          <br />
        </div>
        <div className="main">
          <span>LinkedIn post URL 2&nbsp;&nbsp;</span>
          <input type="text" id="url2" name="url2" onChange={(e) => { setselectedurl2(e.target.value) }} value={selectedurl2} />&nbsp;&nbsp;
          <button id="pasteButton" className="posting_time" style={{backgroundColor:'#0050b2', color:'#fff', border: '0px', borderRadius:'5px', padding:'5px', cursor:'pointer', marginBottom:'5px' }} onClick={handlePasteButtonClick2}>Paste</button>
          &nbsp;&nbsp;
          <div className="output">
            <span id="label">Posted on: </span>
            <span id="date2" />
          </div>
          <br />
        </div>
        <div className="main">
          <span>LinkedIn post URL 3&nbsp;&nbsp;</span>
          <input type="text" id="url3" name="url3" onChange={(e) => { setselectedurl3(e.target.value) }} value={selectedurl3} />
          &nbsp;&nbsp;
          <button id="pasteButton" className="posting_time" style={{backgroundColor:'#0050b2', color:'#fff', border: '0px', borderRadius:'5px', padding:'5px', cursor:'pointer', marginBottom:'5px' }} onClick={handlePasteButtonClick3}>Paste</button>
          &nbsp;&nbsp;
          <div className="output">
            <span id="label">Posted on: </span>
            <span id="date3" />
          </div>
          <br />
        </div>
        <div className="main">
          <span>LinkedIn post URL 4&nbsp;&nbsp;</span>
          <input type="text" id="url4" name="url4" onChange={(e) => { setselectedurl4(e.target.value) }} value={selectedurl4} />
          &nbsp;&nbsp;
          <button id="pasteButton" className="posting_time" style={{backgroundColor:'#0050b2', color:'#fff', border: '0px', borderRadius:'5px', padding:'5px', cursor:'pointer', marginBottom:'5px' }} onClick={handlePasteButtonClick4}>Paste</button>
          &nbsp;&nbsp;
          <div className="output">
            <span id="label">Posted on: </span>
            <span id="date4" />
          </div>
          <br />
        </div>
        <div className="main">
          <span>LinkedIn post URL 5&nbsp;&nbsp;</span>
          <input type="text" id="url5" name="url5" onChange={(e) => { setselectedurl5(e.target.value) }} value={selectedurl5} />
          &nbsp;&nbsp;
          <button id="pasteButton" className="posting_time" style={{backgroundColor:'#0050b2', color:'#fff', border: '0px', borderRadius:'5px', padding:'5px', cursor:'pointer', marginBottom:'5px' }} onClick={handlePasteButtonClick5}>Paste</button>
          &nbsp;&nbsp;
          <div className="output">
            <span id="label">Posted on: </span>
            <span id="date5" />
          </div>
          <br />
        </div>
        <br />
        <button class="posting_time" id="getPostingTime" onClick={getDate}>
          <span>GET POSTING TIME</span>
          </button>
      </div>
    </div>
  )
}

export default Time;
